import React, { useState, useMemo } from 'react';
import { Chip, Menu, MenuItem } from '@mui/material';
import chipFilterStyles from './ChipFilterStyles';

const ChipFilter = ({
  label,
  type,                 
  values,
  selectedValues,
  onToggle,
  onClear,
  labelMap = {},
  closeOnSelectProp,     
}) => {
  const [anchorPos, setAnchorPos] = useState(null);

  const handleOpen = (e) => {
    setAnchorPos({ top: e.clientY, left: e.clientX });
  };
  const handleClose = () => setAnchorPos(null);

  const closeOnSelect = useMemo(() => {
    if (typeof closeOnSelectProp === 'boolean') return closeOnSelectProp;
    return type !== 'dateRange' && type !== 'datetimeRange' && type !== 'timeRange';
  }, [type, closeOnSelectProp]);

  const isActive = selectedValues.length > 0;
  const chipStyle = isActive ? chipFilterStyles.activeChip : chipFilterStyles.chip;
  const displaySelected = selectedValues.map(val => labelMap[val] || val).join(', ');

  const handleSelect = (opt) => {
    onToggle(type, opt);
    if (closeOnSelect) handleClose();
  };

  const handleClear = () => {
    onClear(type);
    handleClose();
  };

  return (
    <>
      <Chip
        label={`${label}: ${isActive ? displaySelected : 'All'}`}
        onClick={handleOpen}
        sx={chipStyle}
      />

      <Menu
        anchorReference="anchorPosition"
        anchorPosition={anchorPos}
        open={!!anchorPos}
        onClose={handleClose}
        PaperProps={{ style: { maxHeight: 300, overflowY: 'auto' } }}
      >
        {values.map(opt => (
          <MenuItem
            key={opt}
            selected={selectedValues.includes(opt)}
            onClick={() => handleSelect(opt)}
          >
            {labelMap[opt] || opt}
          </MenuItem>
        ))}
        <MenuItem onClick={handleClear} sx={chipFilterStyles.clearAll}>
          Clear
        </MenuItem>
      </Menu>
    </>
  );
};

export default ChipFilter;
